{
  "replaceMessage": "للاستبدال، قم بإفلات الملف"
}
